import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }

  return to;
};

import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunkMiddleware from "redux-thunk";
import { LoginReducer } from "./login/Reducers";
import { ImSessionReducer } from "./chat/im/Reducers";
import localStorageMiddleware from "./localStorageMiddleware";
import loadChatHistoryMiddleware from "./loadChatHistoryMiddleware";
import { ContactReducer } from "./chat/contacts/Reducers";
import { MessageReducer } from "./chat/messages/Reducers";
import { IS_PROD } from "@/common/fhtGlobalEnv";
var rootReducer = combineReducers({
  loginSession: LoginReducer,
  imSession: ImSessionReducer,
  contact: ContactReducer,
  message: MessageReducer
});
var composeEnhancers = compose;

if (!IS_PROD && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
  composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
}

function configureStore() {
  var middlewares = [thunkMiddleware, loadChatHistoryMiddleware, localStorageMiddleware];
  var middleWareEnhancer = applyMiddleware.apply(void 0, __spreadArray([], __read(middlewares)));
  var store = createStore(rootReducer, composeEnhancers(middleWareEnhancer));
  return store;
}

var store = configureStore();
export default store;